function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { withSpacing } from '../lib/hoc/withSpacing';
const StyledImage = styled.img.withConfig({
  displayName: "Image__StyledImage",
  componentId: "sc-1mlpj40-0"
})(["display:", ";width:", ";height:", ";max-width:100%;border-radius:", ";", ";", ";"], x => x.$inline ? 'inline-block' : 'block', x => x.$width, x => x.$height, x => x.$borderRadius, x => x.$centered && css(["margin:0 auto;"]), x => x.$inline && css(["vertical-align:top;"]));
const ImageMask = styled.div.withConfig({
  displayName: "Image__ImageMask",
  componentId: "sc-1mlpj40-1"
})(["position:relative;display:", ";overflow:hidden;padding-bottom:", ";max-width:", ";width:100%;height:0;border-radius:", ";z-index:1;", ";", ";"], x => x.$inline ? 'inline-block' : 'block', x => x.$maskHeight, x => x.$maskWidth, x => x.$borderRadius, x => x.$centered && css(["margin:0 auto;"]), x => x.$inline && css(["vertical-align:top;"]));
const MaskedImage = styled.img.withConfig({
  displayName: "Image__MaskedImage",
  componentId: "sc-1mlpj40-2"
})(["position:absolute;top:50%;left:50%;min-width:", ";min-height:", ";max-width:100%;max-height:100%;border:0;transform:", ";object-fit:cover;", ";", ";"], x => x.$maskWidth, x => x.$maskHeight, x => `translate(${x.$x}, ${x.$y})`, x => x.$width && css(["width:", ";"], x => x.$width), x => x.$height && css(["height:", ";"], x => x.$height)); // TODO: should extend HTMLProps<> to get all img props (like loading) but src is incompatible: can't be ReactNode

const ImageFunc = (_ref) => {
  let {
    alt,
    centered = false,
    height = 'auto',
    inline = true,
    masked = false,
    maskHeight = '100px',
    maskWidth = '100px',
    onClick,
    radius = '0px',
    src,
    title,
    width = 'auto',
    x = '-50%',
    y = '-50%'
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["alt", "centered", "height", "inline", "masked", "maskHeight", "maskWidth", "onClick", "radius", "src", "title", "width", "x", "y"]);

  return masked ? /*#__PURE__*/React.createElement(ImageMask, _extends({
    $borderRadius: radius,
    $centered: centered,
    $inline: inline,
    $maskHeight: maskHeight,
    $maskWidth: maskWidth,
    onClick: onClick
  }, rest), /*#__PURE__*/React.createElement(MaskedImage, {
    $height: height,
    $maskHeight: maskHeight,
    $maskWidth: maskWidth,
    $width: width,
    $x: x,
    $y: y,
    alt: alt,
    src: src,
    title: title
  })) : /*#__PURE__*/React.createElement(StyledImage, _extends({
    $borderRadius: radius,
    $centered: centered,
    $height: height,
    $inline: inline,
    $width: width,
    onClick: onClick,
    src: src,
    alt: alt,
    title: title
  }, rest));
};

export const Image = withSpacing(ImageFunc);